import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';
import DropdownSegment from '@/components/DropdownSegment';

const listItems = (conditions) => conditions.map(({ code, name }) => ({
  key: `condition_${code}`,
  text: name,
  value: code,
  description: code,
}));

const ConditionsDropdown = ({
  conditions,
  disabled,
  error,
  onChange,
  readStatus,
  selectedCondition,
  withDescription,
}) => {
  const intl = useIntl();
  return (
    <>
      <Dropdown
        className="aridhia-workflows-dropdown"
        options={listItems(conditions)}
        value={selectedCondition?.code}
        disabled={disabled}
        fluid
        selection
        error={!!error}
        placeholder={intl.formatMessage({
          id: 'dataset.condition.dropdown.placeholder',
        })}
        loading={readStatus === states.PENDING}
        onChange={(e, { value }) => onChange(value)}
      />
      {withDescription && selectedCondition?.description && (
        <DropdownSegment
          className="aridhia-condition-dropdown-segment"
          messageText={`**${selectedCondition.code}:** ${selectedCondition.description}`}
          markdown
        />
      )}
    </>
  );
};

export default ConditionsDropdown;
